import React, { useEffect } from "react";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store";
import { getProductsLists } from "./pages/Loja/products";
import { BrowserRouter, useLocation } from "react-router-dom";
import ThemeContextProvider from "./Context/ThemeContext";
import { pageview } from "./analytics/ga";

function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    const url = location.pathname + location.search;
    pageview(url);
  }, [location.pathname, location.search]);

  return null;
}

store.dispatch(getProductsLists());

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AnalyticsListener />
        <ThemeContextProvider>
          <App />
        </ThemeContextProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
